module.exports = __webpack_public_path__ + "img/img14.47c16d94.svg";